import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
import requestState from "../helpers/requestState";

const API_URL = axiosUrl.getAxiosUrl();

class AuthService {
  async login(user) {
    return await axios
      .post(API_URL + "users/authenticate", {
        username: user.username,
        password: user.password
      })
      .then(async () => {
        requestState.isLogoutInProgress = false;
        requestState.isRefreshing = false;
        requestState.isRateLimitActive = false;
        requestState.refreshPromise = null;
        await this.getAuthUserData();
      })
      .catch(error => {
        store.commit("auth/setAuthUser", null);
        store.commit("auth/updateModalError", error.response.data);
        store.commit("auth/enableModalError");
      });
  }

  async logout(serverSideLogout) {
    sessionStorage.removeItem("searchText");
    sessionStorage.removeItem("durationPhrase");
    sessionStorage.removeItem("searchOnlyName");
    sessionStorage.removeItem("filterByICTUFlag");
    sessionStorage.removeItem("statusesString");
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    sessionStorage.removeItem("updatedDateGreaterThan");
    sessionStorage.removeItem("updatedDateLessThan");
    sessionStorage.removeItem("schemeStartGreaterThan");
    sessionStorage.removeItem("schemeStartLessThan");
    sessionStorage.removeItem("schemeEndGreaterThan");
    sessionStorage.removeItem("schemeEndLessThan");
    sessionStorage.removeItem("publicationStatusesGroup");
    sessionStorage.removeItem("schemeStatusGroup");
    sessionStorage.removeItem("minBudget");
    sessionStorage.removeItem("maxBudget");
    sessionStorage.removeItem("organisationsInclude");
    sessionStorage.removeItem("organisationsExclude");
    sessionStorage.removeItem("searchOnAdministratingOrgs");
    sessionStorage.removeItem("searchOnAdvisingOrgs");
    sessionStorage.removeItem("searchOnFundingOrgs");
    sessionStorage.removeItem("searchOnRecipientOrgs");
    sessionStorage.removeItem("selectedLocations");
    sessionStorage.removeItem("newsSelectedLocations");
    sessionStorage.removeItem("selectedAudiences");
    sessionStorage.removeItem("selectedPurposes");
    sessionStorage.removeItem("selectedSchemeTypes");
    sessionStorage.removeItem("selectedProjectTypes");
    sessionStorage.removeItem("schemeUpdatesToAdd");
    sessionStorage.removeItem("showAllLanguageVersions");

    store.commit("auth/setAuthUser", null);

    if (serverSideLogout) return await axios.post(API_URL + "auth/logout");
  }

  async getAuthUserData() {
    return await axios
      .get(API_URL + "auth/getAuthUserData")
      .then(response => {
        store.commit("auth/setAuthUser", response.data);
      })
      .catch(error => {
        throw error;
      });
  }

  async refreshToken() {
    return await axios.post(API_URL + "auth/refresh").catch(error => {
      throw error;
    });
  }
}

export default new AuthService();
